export default function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-array/src/descending.js
// module id = 1092
// module chunks = 0